export default {
    SIZE_LARGE: 128,
    SIZE_MEDIUM: 100,
    SIZE_SMALL: 'size_small',
    THEME_PRIMARY: '#0053A1',
    THEME_SECONDARY: '#FFFFFF',
    FONT_BOLD_DISPLAY: 'SFProDisplayBold',
    FONT_BOLD: 'SFProTextBold',
    FONT_LIGHT: 'SFProTextLight',
}